<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Impressum</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Impressum</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Impressum Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <h2 class="text-3xl font-bold mb-6">Impressum</h2>

        <p class="mb-4"><strong>HIGETO e.V.</strong><br>
            Mellingerstraße 47<br>
            31141 Hildesheim</p>

        <p class="mb-4">
            <strong>Telefon:</strong> <a href="tel:+4917655761387" class="text-blue-600">+49 176 55761387</a><br>
            <strong>E-Mail:</strong> <a href="mailto:hgesundheit.togo@gmail.com" class="text-blue-600">hgesundheit.togo&commat;gmail.com</a><br>
            <strong>Website:</strong> <a href="https://higeto.de" target="_blank" class="text-blue-600">www.higeto.de</a>
        </p>

        <p class="mb-4">
            <strong>Vereinsregistrierung:</strong><br>
            Hilfe für Gesundheit in Togo e.V.<br>
            Registrierungsnummer: NZS VR 201848<br>
            Eingetragen im Vereinsregister Hildesheim<br>
            <strong>Registergericht:</strong> Amtsgericht Hildesheim<br>
            <!--strong>Registernummer:</strong> [z.B. VR 12345]<br-->
            <strong>Steuernummer:</strong> 30/270/07892
        </p>

        <p class="mb-4">
            <strong>Bankverbindung:</strong><br>
            IBAN: DE54 2519 0001 0445 0612 00<br>
            BIC: VOHADE2H (Hannoversche Volksbank eG)
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Erklärung zur digitalen Zugänglichkeit</h3>
        <p class="mb-4">
            HIGETO e.V. setzt sich für digitale Barrierefreiheit ein und bemüht sich, die Benutzerfreundlichkeit für alle Menschen kontinuierlich zu verbessern. Wir orientieren uns an den Web Content Accessibility Guidelines (WCAG) und streben Konformität mit diesen Standards an.
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Feedback zur Barrierefreiheit</h3>
        <p class="mb-4">
            Wir freuen uns über Ihr Feedback zur Barrierefreiheit unserer Website. Bitte kontaktieren Sie uns, wenn Sie auf Hindernisse stoßen:
        </p>
        <p class="mb-4">
            <strong>Telefon:</strong> <a href="tel:+4917655761387" class="text-blue-600">+49 176 55761387</a><br>
            <strong>E-Mail:</strong> <a href="mailto:hgesundheit.togo@gmail.com" class="text-blue-600">hgesundheit.togo&commat;gmail.com</a>
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Hosting</h3>
        <p class="mb-4">
            Unsere Website wird auf Servern in Deutschland gehostet ( bei Strato). Die Datenverarbeitung erfolgt gemäß DSGVO.
        </p>

        <h3 class="text-xl font-semibold mt-8 mb-2">Sitz der Gesellschaft</h3>
        <p class="mb-4">
            HIGETO e.V.<br>
            Mellingerstraße 47<br>
            31141 Hildesheim
        </p>
    </div>
</section>
<app-subscribe></app-subscribe>
